import React from 'react'

export const IconQuestion: React.FC = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z M8.08984 8.00085C8.57528 6.62089 9.98523 5.79225 11.427 6.03956C12.8688 6.28686 13.922 7.538 13.9198 9.00085C13.9198 11.0008 10.9198 12.0008 10.9198 12.0008 M11 16.0057C11.0001 16.0009 11 16 11.0003 16.0067"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
